<template>
  <div>
    <div class="breadcrumb-wrap">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-custom"
      >
        <el-breadcrumb-item>新增文章</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div>
      <div class="title-wrap">
        <div class="left-text">标题：</div>
        <el-input v-model="title" placeholder="请输入标题" />
      </div>
    </div>
    <div>
      <div class="title-wrap d-w">
        <div class="left-text">描述：</div>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入描述"
          v-model="des"
        />
      </div>
    </div>
    <div class="m-w">
      <div class="title-wrap d-w">
        <div class="left-text">封面</div>
        <div>
          <el-upload
            :on-success="handleAvatarSuccess"
            :data="uploadData"
            class="a-u-d"
            :action="action"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="ava" />
            <i v-else class="el-icon-plus a-u-d-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="s-w">
        <div class="left-text">标签</div>
        <div>
          <el-select v-model="label" placeholder="请选择">
            <el-option
              v-for="item in labels"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div>
      <div style="border: 1px solid #ccc;">
        <Toolbar
          style="border-bottom: 1px solid #ccc"
          :editor="editor"
          :defaultConfig="toolbarConfig"
          :mode="mode"
        />
        <Editor
          style="height: 50vh; overflow-y: hidden;"
          v-model="html"
          :defaultConfig="editorConfig"
          :mode="mode"
          @onCreated="onCreated"
        />
      </div>
    </div>
    <div class="submit-wrap">
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../components/LoadingNoDialog.vue";
import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
import TagImgUpload from "./component/TagImgUpload.vue";
import LabelDialog from "./component/LabelDialog.vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { DomEditor } from "@wangeditor/editor";
import OssUpload from "../../common/OssUpload";
let ossResultProxy = null;

export default {
  name: "Role",
  data() {
    const that = this;
    return {
      loading: false,
      tagImgDialog: false,
      tagInfo: {
        objectKey: "",
        imgUrl: "",
      },
      subTagLoading: false,
      isAdd: true,
      title: "",
      des: "",
      labels: [],
      label: "",
      editor: null,
      html: "",
      toolbarConfig: {
        toolbarKeys: [
          "headerSelect",
          "blockquote",
          "|",
          "bold",
          "underline",
          "italic",
          {
            key: "group-more-style",
            title: "更多",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M204.8 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M505.6 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M806.4 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path></svg>',
            menuKeys: ["through", "code", "sup", "sub", "clearStyle"],
          },
          "color",
          "bgColor",
          "|",
          "fontSize",
          "fontFamily",
          "lineHeight",
          "|",
          "bulletedList",
          "numberedList",
          "todo",
          {
            key: "group-justify",
            title: "对齐",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',
            menuKeys: [
              "justifyLeft",
              "justifyRight",
              "justifyCenter",
              "justifyJustify",
            ],
          },
          {
            key: "group-indent",
            title: "缩进",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>',
            menuKeys: ["indent", "delIndent"],
          },
          "|",
          "insertLink",
          {
            key: "group-image",
            title: "图片",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
            // menuKeys: ["insertImage", "uploadImage"],
            menuKeys: ["uploadImage"],
          },
          // {
          //   key: "group-video",
          //   title: "视频",
          //   iconSvg:
          //     '<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>',
          //   menuKeys: ["insertVideo", "uploadVideo"],
          // },
          "insertTable",
          // "codeBlock",
          "divider",
          "|",
          "undo",
          "redo",
          "|",
          "fullScreen",
        ],
      },
      imgHost: null,
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              const loading = that.$loading({
                lock: true,
                text: "上传中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
              });
              let ossUpload = new OssUpload();
              //await ossUpload.setOssPolicy(4);
              let ossResult = await ossUpload.uploadFileForFileStream(file, 4);
              that.imgHost = ossResult.host;
              let imgUrl = ossResult.url;
              insertFn(imgUrl);
              loading.close();
            },
          },
        },
      },
      mode: "default", // or 'simple'
      action: "",
      uploadData: {},
      imageUrl: "",
      isEdit: false,
      id: -1,
    };
  },
  components: {
    ElButton,
    LoadingNoDialog,
    TagImgUpload,
    LabelDialog,
    Editor,
    Toolbar,
  },
  async mounted() {
    const loading = this.$loading({
      lock: true,
      text: "加载中",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    await this.getAllLabels();
    let id = this.$route.query.id;
    if (id) {
      this.id = parseInt(id);
      await this.getConfig();
      await this.initData();
    }

    loading.close();
  },

  beforeDestroy() {
    ossResultProxy = null;
  },
  methods: {
    async getConfig() {
      let r = await axios.get("/admin/get-config");
      if (r.code == 0) {
        this.imgHost = r.data.resoureHost;
      }
      return r;
    },
    async initData() {
      this.isEdit = true;

      let r = await axios.get("/admin/get-a-article", {
        params: {
          id: this.id,
        },
      });
      if (r.code == 0) {
        let info = r.data;
        this.html = info.content;
        this.title = info.title;
        this.imageUrl = info.imgUrl;
        this.des = info.des;

        this.label = info.labelId;
        ossResultProxy = {
          objectKey: info.img,
        };
      }
      return r;
    },
    handleAvatarSuccess(response) {
      if (ossResultProxy != null) {
        this.imageUrl = ossResultProxy.url;
      }
    },
    async beforeAvatarUpload() {
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let ossUpload = new OssUpload();
      let ossResult = await ossUpload.getElOssPolicy(2);
      this.action = ossResult.host;
      this.uploadData = ossResult.uploadData;
      ossResultProxy = ossResult;
      loading.close();
      return true;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      setTimeout(() => {
        const toolbar = DomEditor.getToolbar(editor);
      }, 1200);
    },
    async getAllLabels() {
      try {
        let res = await axios.get("/admin/get-lable-lists", {
          params: { size: 10000000 },
        });
        if (res.code == 0) {
          this.labels = res.data.rows.map((item) =>
            Object.assign({ label: item.name, value: item.id })
          );
        } else {
        }
        return res;
      } catch (e) {
        console.error(e);
        return null;
      }
    },
    async submit() {
      if (this.title == "") {
        this.$message.warning("请输入标题");
        return;
      }
      if (this.des == "") {
        this.$message.warning("请输入描述");
        return;
      }
      if (ossResultProxy == null) {
        this.$message.warning("请上传封面");
        return;
      }
      let content = this.editor.getHtml();
      if (this.label == null) {
        this.$message.warning("请选择标签");
        return;
      }
      let reg = new RegExp(this.imgHost, "g");
      content = content.replace(reg, "");
      if (content == "<p><br></p>") {
        this.$message.warning("请输入内容");
        return;
      }
      let labelId = parseInt(this.label);
      if (this.isEdit) {
        let r = await axios.post("/admin/edit-article", {
          id: this.id,
          img: ossResultProxy.objectKey,
          content: content,
          des: this.des,
          title: this.title,
          labelId: labelId,
        });
        if (r.code == 0) {
          this.$message.success("修改成功");
          this.$router.push("/article");
        } else {
          this.$message.warning("修改失败");
        }
      } else {
        let r = await axios.post("/admin/article-create", {
          img: ossResultProxy.objectKey,
          content: content,
          des: this.des,
          title: this.title,
          labelId: labelId,
        });
        if (r.code == 0) {
          this.$message.success("新增成功");
          this.$router.push("/article");
        } else {
          this.$message.warning("新增失败");
        }
      }
    },
  },
};
</script>
<style scoped>
.submit-wrap {
  padding-top: 20px;
  display: flex;
  justify-content: center;
}
.title-wrap {
  display: flex;
  align-items: center;
}
.left-text {
  width: 60px;
  font-size: 18px;
  display: flex;
  justify-content: center;
}
.d-w {
  margin: 10px 0px;
}
.a-u-d {
  border: 1px dashed #ddd;
}
.a-u-d .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid #ddd;
}

.a-u-d .el-upload:hover {
  border-color: #409eff;
}

.a-u-d-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.ava {
  width: 100px;
  height: 100px;
  display: block;
}
.s-w {
  display: flex;
  align-items: center;
  margin-left: 80px;
}
.m-w {
  display: flex;
  align-content: center;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/ArticleAdd.vue